var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseDivisions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 126 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 140.833V47.0834L62.9998 0.128418L125.5 47.0834V140.833H0.5ZM12.9998 128.333H73.4167V100.208H12.9998V128.333ZM85.9163 128.333H113V100.208H85.9163V128.333ZM12.9998 87.7082H40.0833V59.7113H12.9998V87.7082ZM52.5829 87.7082H113V59.7113H52.5829V87.7082ZM21.0283 47.2918H104.971L62.9998 15.8332L21.0283 47.2918Z",
    fill: "#000030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseDivisions);
export default __webpack_public_path__ + "static/media/house_divisions.b0b9d3c7d767dbb9f9e349a8ae79fe42.svg";
export { ForwardRef as ReactComponent };